module.exports = __webpack_public_path__ + "static/media/progress_marke.1454c5ec.svg";